import {styled} from '@mui/material';

const DialogForm = styled('form')({
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
});

export default DialogForm;
